'use strict';

const { h } = require('phy');
const { pruneData } = require('../../support/prune-data');
const { getRelatedTableClass } = require('../../support/category-helper');

const UberCard = require('../../../components/uber_card/uber-card');
const CouponTile = require('./coupon-tile');
const CategoryRelatedTable = require('../../category/views/category-related');
const EmailSubscription = require('../../email_subscription/views/email-subscription');
const DFPAds = require('../../ads/views/fetch-dfp-ad');

const AMOUNT_TO_PRELOAD = 4;
const AMOUNT_BEFORE_INLINE_CONTENT = 3;
const DFP_AD_PREFIX = 'dfp_';

function renderItem({ item, index, routes, media, isTouch, showCallouts }) {
  if (item.type === 'related') {
    return CategoryRelatedTable({
      className: item.className,
      parentCategoryId: item.parentCategoryId,
      categories: item.categories,
      merchants: item.merchants,
      routes,
      isTouch,
    });
  }

  if (item.type === 'email') {
    const { merchantSlug, csrfToken, merchantName } = item;
    const className = 'email-subscription-coupons-list';

    return EmailSubscription({
      csrfToken,
      routes,
      classNames: {
        inner: isTouch
          ? className
          : `${className}.email-subscription-full-width`,
      },
      bhwName: `MerchantEmailSubscription:${merchantSlug}`,
      merchantName,
    });
  }

  if (item.type && item.type.startsWith(DFP_AD_PREFIX)) {
    return DFPAds({
      adType: item.type,
      isTouch,
      index,
      couponsCount: item.couponsCount,
    });
  }

  return CouponTile({
    coupon: item,
    media,
    routes: pruneData(
      routes,
      'redemption:main',
      'redemption:terms',
      'merchant:show'
    ),
    lazy: index >= AMOUNT_TO_PRELOAD,
    showCallouts,
  });
}

function getItems({ related, coupons, merchantSlug, csrfToken, merchantName }) {
  const items = [];

  if (merchantSlug) {
    items.push({
      type: 'email',
      merchantSlug,
      csrfToken,
      merchantName,
    });
  }

  if (related.parentCategoryId) {
    items.push({
      type: 'related',
      className: getRelatedTableClass(coupons, AMOUNT_BEFORE_INLINE_CONTENT),
      ...related,
    });
  }

  return [
    {
      type: 'dfp_ad_top',
      couponsCount: coupons.length,
    },
    ...coupons.slice(0, AMOUNT_BEFORE_INLINE_CONTENT),
    ...items,
    {
      type: 'dfp_ad_inline',
    },
    ...coupons.slice(AMOUNT_BEFORE_INLINE_CONTENT),
    {
      type: 'dfp_ad_bottom',
    },
  ];
}

function getListContent({
  coupons,
  routes,
  isTouch,
  media,
  related,
  merchantSlug,
  csrfToken,
  merchantName,
  showCallouts,
}) {
  if (!coupons || !coupons.length) {
    if (related.parentCategoryId) {
      return renderItem({
        item: {
          type: 'related',
          ...related,
        },
        routes,
        isTouch,
      });
    }
  }

  const items = getItems({
    related,
    coupons,
    merchantSlug,
    csrfToken,
    merchantName,
  });

  return h(
    'ul.coupons-list',
    items.map((item, index) =>
      h(
        'li.coupons-list-row',
        renderItem({
          item,
          index,
          routes,
          media,
          isTouch,
          showCallouts,
        })
      )
    )
  );
}

function CouponsList({
  premium = [],
  coupons,
  routes,
  isTouch,
  related = {},
  media = 'logo',
  attrs = {},
  merchantSlug,
  csrfToken,
  merchantName,
  showCallouts,
}) {
  return h(
    '',
    attrs,
    premium.map(coupon =>
      h(
        '.coupons-list-row',
        UberCard({
          coupon,
        })
      )
    ),
    getListContent({
      coupons,
      routes,
      isTouch,
      media,
      related,
      merchantSlug,
      csrfToken,
      merchantName,
      showCallouts,
    })
  );
}

module.exports = CouponsList;
